module.exports = __webpack_public_path__ + "img/H000180_starfish.1f9ad14b.png";